import React, { useEffect } from 'react';

import { useSlider } from '@/hooks/useSlider';
import useApi from '@/hooks/useApi';

import { ButtonsSlider } from '@/components/global/ButtonSlider';
import { Dashboard } from '@/components/Template/Template6';

import { TRecommendation } from '@/services/requests/Recommendation/types/template6';
import { TInteractionCardClick } from '@/services/requests/Interactions/types';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';

import { getVisibleCardsIdByElement } from '@/helpers/HtmlHelper/getVisibleCardsIdByElement';

import { Card } from './Card';

type TProps = { data: TRecommendation };

export const Slider = ({
  data: {
    fixed_card: fixedCard,
    cards,
    id,
    config,
    theme,
    subtitle,
    events_tag,
  },
}: TProps) => {
  const { Api, traceId } = useApi();

  const { sliderState, moveSlider, containerRef, checkScrollLimit } = useSlider(
    { id, cards, config } as TRecommendation,
    'tabName',
    true,
    '1',
    'vitrine-template6__card',
  );

  const handleOpenModal = async () => {
    await dispatchInteraction<TInteractionCardClick>(Api, 'card-click', {
      recommendationId: id,
      tabName: subtitle,
      cardId: fixedCard.card_id,
      cardPosition: 1,
      cards: getVisibleCardsIdByElement(
        containerRef.current as HTMLElement,
        'card-click',
      ),
    });

    const event = new CustomEvent('smls-ffp-optin-open', {
      detail: {
        contentId: `mod_${config.params.name.toLowerCase()}_logged`,
        isMagno: config.params.isMagno,
        traceId,
        recommendationId: id,
      },
    });
    window.dispatchEvent(event);
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = 0;
    }
  }, [cards, containerRef]);

  return (
    <div className="vitrine-template6__slider">
      <ButtonsSlider
        handleClick={e => {
          moveSlider(e);
        }}
        sliderScroll={sliderState.scroll}
        checkScrollLimit={checkScrollLimit}
        template="6"
      />
      <div
        className="vitrine-template6__cards"
        ref={containerRef}
        data-testid="cards"
      >
        <Dashboard
          dashboard={fixedCard}
          handleOpenModal={handleOpenModal}
          events_tag={events_tag}
        />
        {cards.map(card => {
          return <Card data={card} theme={theme} key={card.id} />;
        })}
      </div>
      <div className="vitrine-template6__slider-dots">
        {cards.length > 1 &&
          cards.map((card, i) => {
            return (
              <span
                key={`dot${card.id}`}
                className={`vitrine-template6__slider-dot${
                  i + 1 === sliderState.current ? ' current' : ''
                }`}
              >
                {i + 1}
              </span>
            );
          })}
      </div>
    </div>
  );
};
